module.exports = __webpack_public_path__ + "img/morocco.b4cb2471.svg";